import {
  call, put, takeLatest, all, select
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import { actions } from 'react/api/actions/ticketHub';
import filterTypes from 'react/components/TicketHub/filterTypes';

function throwErrorToLog(message) {
  return console.error(message); // eslint-disable-line
}

function setCriteriaChain(query, filterType, userLoggedId) {
  let criteriaChain;

  if (filterType === filterTypes.default) {
    criteriaChain = [
      {
        or: [
          { matchMode: 'ANYWHERE', attr: 'ticketLinked.route.description', eq: query },
          { matchMode: 'ANYWHERE', attr: 'ticketLinked.location.description', eq: query },
          { matchMode: 'ANYWHERE', attr: 'userCreated.name', eq: query }
        ]
      }
    ];
  } else if (filterType === filterTypes.organization) {
    criteriaChain = [
      {
        and: [
          { attr: 'organization.id', eq: query }
        ]
      }
    ];
  } else if (filterType === filterTypes.assignedToMe && query) {
    criteriaChain = [
      {
        and: [
          { attr: 'userAssigned.id', eq: userLoggedId }
        ]
      }
    ];
  } else {
    criteriaChain = [{ and: [] }];
  }

  return criteriaChain;
}

function* fetchData(payload) {
  const criteria = [
    'id',
    'key',
    'title',
    'created',
    'dueDate',
    'modified',
    'whenStatusChanged',
    'ticketStatus',
    'ticketType.id',
    'ticketType.description',
    'ticketResolution.id',
    'ticketResolution.description',
    'userCreated.id',
    'userCreated.name',
    'userModified.id',
    'userModified.name',
    'userAssigned.id',
    'userAssigned.name',
    'lastUserChangedStatus.id',
    'lastUserChangedStatus.name',
    'ticketLinked.*',
    'ticketLinked.route.*',
    'ticketLinked.location.*',
    'ticketLinked.user.*',
    'organization.*'
  ];

  const data = {
    criteriaChain: [{ and: [] }],
    sort: [
      {
        attr: 'id',
        type: 'DESC'
      }
    ]
  };

  if (payload) {
    const { query, filterType } = payload;
    const { user } = yield select();
    const userLoggedId = user.get('id');

    data.criteriaChain = setCriteriaChain(query, filterType, userLoggedId);
  }

  const url = `/Ticket/restrictions?criteria={"filters":${JSON.stringify(criteria)}}`;
  const encodedUrl = encodeURI(url);
  return yield call(defaultFetch, encodedUrl, data, 'POST');
}

function* fetchTickets({ payload }) {
  yield put({ type: actions.setLoading, payload: true });

  const response = yield call(fetchData, payload);
  const { error } = response;

  if (!error) {
    const { user } = yield select();
    const userLoggedId = user.get('id');

    const filteredTickets = response
      .filter((ticket) => ticket.userCreated.id !== userLoggedId)
      .sort((a, b) => {
        if (a.ticketStatus === b.ticketStatus) {
          return b.id - a.id;
        }

        const sortPriority = {
          RE_ASSIGNED: 1,
          WAITING_SERVICE: 1,
          OPEN: 2,
          REOPENED: 3,
          ASSIGNED: 4,
          CLOSED: 5
        };

        const leftPriority = sortPriority[a.ticketStatus];
        const rightPriority = sortPriority[b.ticketStatus];

        return leftPriority > rightPriority ? 1 : -1;
      });

    yield put({
      type: actions.setTicketsToState,
      payload: {
        tickets: filteredTickets
      }
    });
  } else {
    throwErrorToLog('Error trying to fetch Tickets to hub');
  }

  yield put({ type: actions.setLoading, payload: false });
}

function* watchTicketHubOpen() {
  yield takeLatest(actions.fetchTickets, fetchTickets);
}

export default function* () {
  yield all([
    watchTicketHubOpen()
  ]);
}
